import React from 'react';
import './empresa.css';

const Vision = () => {
  return (
    <section id="vision" className="empresa-section">
      <div className="empresa-container">
        <h2 className="empresa-title">Visión</h2>
        <p className="empresa-text">
          Ser referentes en educación artística a nivel nacional, promoviendo la creatividad como motor de cambio social
          y profesional. Buscamos transformar vidas a través del arte, impulsando trayectorias sostenibles y una comunidad
          inclusiva que inspire y conecte talento con oportunidades.
        </p>
      </div>
    </section>
  );
};

export default Vision;
